import React from 'react';
import styled from 'styled-components';

export default props => {
	// Check if link is internal.
	const href = props.href;
	let anchor;

	if (typeof window !== 'undefined') {
		const sameDomain = window && new RegExp('/' + window.location.host + '/');
		anchor =
			href.substring(0, 1) === '#' ||
			sameDomain.test(href) ||
			href === undefined ||
			href === '' ||
			href === '#' ||
			href === '#!';
	} else {
		anchor = href.substring(0, 1) === '#';
	}

	return (
		<Wrap
			{...props}
			target={anchor ? '_self' : props.target ? props.target : '_blank'}
			rel="noopener noreferrer"
			onClick={e => {
				if (typeof props.onClick === `function`) {
					props.onClick();
				}

				e.preventDefault();
				e.stopPropagation();

				// Go to the link.
				anchor && window.open(href, '_self');
				!anchor && window.open(href, '_blank');

				if (!anchor && window.ga) {
					console.log('LOGGING GA');
					window.ga(`send`, `event`, {
						eventCategory: `EXTERNAL_LINK`,
						eventAction: `CLICK`,
						eventLabel: href,
						transport: 'beacon',
					});
				}

				return false;
			}}
		>
			{props.children}
		</Wrap>
	);
};

const Wrap = styled.a`
	color: ${p => p.theme.c2};
	transition: all 0.4s ease-in;
	text-decoration: none;
	border-bottom: 3px solid ${p => p.theme.cg2};
	box-shadow: inset 0 -1rem 0 ${p => p.theme.cg2};
	transition: 0.4s all ease-out;

	&:hover {
		box-shadow: inset 0 -5.5rem 0 ${p => p.theme.ct};
		border-bottom: 3px solid ${p => p.theme.ct};
	}
`;
